import { toast } from "react-toastify";
import { call, put, takeLatest } from "redux-saga/effects";
import * as actions from "./Actions";
import * as api from "./Api";
import Types from "./Types";

const extractList = (body) => {
  if (Array.isArray(body)) return body;
  if (Array.isArray(body?.data)) return body.data;
  if (Array.isArray(body?.data?.data)) return body.data.data;
  if (Array.isArray(body?.attendence)) return body.attendence;
  if (Array.isArray(body?.attendance)) return body.attendance;
  return [];
};

function* listAttendenceForStudent({ payload }) {
  try {
    yield put(actions.attendenceLoading(true));
    const result = yield call(api.listAttendenceForStudent, payload);
    yield put(actions.listAttendenceForStudentSuccess(extractList(result?.data)));
  } catch (error) {
    yield put(actions.listAttendenceForStudentFail());
    toast.error(
      error?.response?.data?.message || "فشل تحميل سجل الحضور"
    );
  } finally {
    yield put(actions.attendenceLoading(false));
  }
}

function* deleteAttendence({ payload, action }) {
  try {
    yield put(actions.attendenceLoading(true));
    const result = yield call(api.deleteAttendence, payload);
    yield put(actions.deleteAttendenceSuccess(payload));
    toast.success(result?.data?.message || "تم حذف سجل الحضور");
    action && action();
  } catch (error) {
    yield put(actions.deleteAttendenceFail());
    toast.error(error?.response?.data?.message || "فشل حذف سجل الحضور");
  } finally {
    yield put(actions.attendenceLoading(false));
  }
}

export default function* AttendenceSaga() {
  yield takeLatest(
    Types.LIST_ATTENDENCE_FOR_STUDENT_REQUEST,
    listAttendenceForStudent
  );
  yield takeLatest(Types.DELETE_ATTENDENCE_REQUEST, deleteAttendence);
}
